export const isObject = (obj) => obj && obj.constructor === Object;
